<template>
  <div class="main products home">
    <div class="bannerBackground">
      <div class="banner">
        <p style="color: #fff; font-weight: bold">{{ $t('title1') }}</p>
        <p style="color: #5ea2ec; font-weight: bold">{{ $t('title2') }}</p>
        <p style="color: rgba(238, 238, 238, 0.8); font-size: 24px">{{ $t('subtitle') }}</p>
      </div>
      <div class="get-start">
        <div class="get-start-inner" :style="{'max-width': longTxt ? '565px' : '370px'}">
          <el-input :class="inputStatus" :style="{'max-width': longTxt ? '565px' : '370px'}" @keyup.stop.enter.native="getStart(true)" v-model="startInput" :placeholder="$t('placeholder')"></el-input>
          <p class="err-tips" v-show="isInputErr"><img src="../../assets/images/20181212/icon_prompt.png" alt="" class="icon-prompt">{{ errTipsTxt }}</p>
        </div>
        <el-button :style="{'width': longTxt ? '180px' : '160px'}" @click="getStart(true)">{{ $t('getstart') }}</el-button>
      </div>
    </div>
    <div class="mainContent">
      <div class="home-part crait-advantage">
        <div class="home-info">
          <p class="home-title title">{{ $t('contitle') }}</p>
        </div>
        <div class="home-intro">
          <div  class="tool-pic">
            <img src="../../assets/images/20180102/collaboration_pic@2x.png" alt="">
          </div>
          <ul class="home-crait-advantage-intro">
            <li>
              <p class="home-intro-title title">{{ $t('intro1-title') }}</p>
              <p class="home-intro-detail">{{ $t('intro1-detail') }}</p>
            </li>
          </ul>
        </div>
        <!-- <div class="home-intro">
          <ul class="home-crait-advantage-intro secureCommunication">
            <li>
              <p class="home-intro-title title">{{ $t('intro4-title') }}</p>
              <p class="home-intro-detail">{{ $t('intro4-detail') }}</p>
            </li>
          </ul>
          <div  class="tool-pic">
            <img src="../../assets/images/20180102/effectiveness@2x.png" alt="">
          </div>
        </div> -->
        <div class="home-intro">
          <ul class="home-crait-advantage-intro secureCommunication">
            <li>
              <p class="home-intro-title title">{{ $t('intro2-title') }}</p>
              <p class="home-intro-detail">{{ $t('intro2-detail') }}</p>
            </li>
          </ul>
          <div  class="tool-pic">
            <img src="../../assets/images/20180102/communication_pic@2x.png" alt="">
          </div>
        </div>
        <div class="home-intro">
          <div  class="tool-pic">
            <img src="../../assets/images/20180102/organization_pic@2x.png" alt="">
          </div>
          <ul class="home-crait-advantage-intro organization">
            <li>
              <p class="home-intro-title title">{{ $t('intro3-title') }}</p>
              <p class="home-intro-detail">{{ $t('intro3-detail') }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="home-part key-features">
        <div class="home-info">
          <p class="home-title title">{{ $t('keyfeature-title') }}</p>
        </div>
        <div class="home-intro key-feature-intro">
          <ul class="key-feature-lists">
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_chat@2x.png" alt="">
              </div>
              <div class="features-detail title">{{ $t('keyfeature-list1') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_voicecalls@2x.png" alt="">
              </div>
              <div class="features-detail title">{{ $t('keyfeature-list2') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_sharing@2x.png" alt="">
              </div>
              <div class="features-detail title">{{ $t('keyfeature-list3') }}</div>
            </li>
          </ul>
          <ul class="key-feature-lists">
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_synced@2x.png" alt="">
              </div>
              <div class="features-detail title">{{ $t('keyfeature-list4') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_vioce@2x.png" alt="">
              </div>
              <div class="features-detail title">{{ $t('keyfeature-list5') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_clouddrive@2x.png" alt="">
              </div>
              <div class="features-detail title">{{ $t('keyfeature-list6') }}</div>
            </li>
          </ul>
          <div class="learn-more cur"><router-link to="/Feature">{{ $t('learnmore') }}</router-link></div>
        </div>
      </div>
      <div class="home-part download">
        <div class="large-screen">
          <div class="bg-download">
            <div class="get-start">
              <div class="get-start-inner" :style="{'max-width': longTxt ? '645px' : '560px'}">
                <el-input :class="inputStatus" :style="{'max-width': longTxt ? '645px' : '560px'}" @keyup.stop.enter.native="getStart(true)" v-model="startInput" :placeholder="$t('placeholder')"></el-input>
                <p class="err-tips" v-show="isInputErr"><img src="../../assets/images/20181212/icon_prompt.png" alt="" class="icon-prompt">{{ errTipsTxt }}</p>
              </div>
              <el-button :style="{'width': longTxt ? '300px' : '240px'}" @click="getStart(true)">{{ $t('getstart') }}</el-button>
            </div>
            <div class="get-app">{{ $t('download-getApp') }}
              <u @mouseenter="showQrCode('iphone')" @mouseleave="hideQrCode" ref="dlIphone">{{ $t('download-iphone') }}</u> , 
              <u @mouseenter="showQrCode('gphone')" @mouseleave="hideQrCode" ref="dlGphone">{{ $t('download-gphone') }}</u> , 
              <u>{{ $t('download-pc') }}</u> , 
              <u>{{ $t('download-chrome') }}</u>
              <div ref="qrCodeBox" class="qr-code-box" :style="{top: qrCodeBox.top, left: qrCodeBox.left, visibility: qrCodeBox.show}">
                <img src="../../assets/images/20181212/qr_code.png" alt="" class="qr-code">
                <p>{{ $t('download-scanCode') }}</p>
                <p>{{ $t('download-dlApp') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="small-screen">
          <div class="bg-download">
            <p class="dl-title">{{ $t('download-title-m') }}</p>
            <div class="dl-btn" @click="getStart">{{ $t('download-dl-btn') }}</div>
          </div>
        </div>
      </div>
    </div>
    <wx-mask :maskShow="showWxMask"></wx-mask>
  </div>
</template>

<script>
import { getHost } from '../../utils.js'
import getBrowserInfo from '../../assets/js/browser.js'
import WxMask from '../WxMask'
export default {
  metaInfo () {
    return {
      title: this.$i18n.t('h-m-title'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
  name: 'home',
  data () {
    return {
      startInput: '',
      qrCodeBox: {
        show: 'hidden',
        top: 0,
        left: 0
      },
      isInputErr: false,
      errTipsTxt: '',
      showWxMask: false
    }
  },
  components: {
    WxMask
  },
  watch: {
    startInput (val) {
      if (val === '') {
        this.isInputErr = false
      }
    }
  },
  computed: {
    longTxt () {
      if (this.$i18n.locale === 'rus') {
        return true
      }
      return false
    },
    inputStatus () {
      if (this.isInputErr) {
        return 'input-err'
      } else {
        return 'input-def'
      }
    }
  },
  methods: {
    getStart (needCheck) {
      this.startInput = this.startInput.replace(/#/g, '')
      if (needCheck === true) {
        if (window.document.body.clientWidth <= 1024) {
          const iframe = document.createElement('iframe')
          const body = document.body
          iframe.style.cssText = 'display:none;width=0;height=0'
          body.appendChild(iframe)
          iframe.src = 'batchatnew://?crait'
          if (getBrowserInfo.isAndroid()) {
            if (getBrowserInfo.isWX()) {
              this.showWxMask = true
            } else {
              if (this.$i18n.locale === 'cn') {
                location.href = 'https://www.craitcorp.com/download/crait.apk'
              } else {
                location.href = 'https://play.google.com/store/apps/details?id=com.craitapp.crait'
              }
            }
          } else if (getBrowserInfo.isIOS()) {
            location.href = 'https://itunes.apple.com/app/id1227620003'
          }
        } else {
          const checkRes = this.checkInput(this.startInput)
          if (checkRes === 'success') {
            this.isInputErr = false
            if (window.document.body.clientWidth <= 1024) {
              let href = getHost('share') + `/option/share/index.html#/?token=1531291861KhBqlb&type=invite&account=${this.startInput}&source=website&v=${new Date().getTime()}`
              window.location.href = href
              console.log(href)
            } else {
              window.location.href = `/login/index.html#/login/signup?account=${this.startInput}&source=website&v=${new Date().getTime()}`
            }
          } else if (checkRes === 'errEmail') {
            this.isInputErr = true
            this.errTipsTxt = this.$t('err-tip-email')
          } else if (checkRes === 'errPhone') {
            this.isInputErr = true
            this.errTipsTxt = this.$t('err-tip-phone')
          }
        }
      } else {
        if (window.document.body.clientWidth <= 1024) {
          const iframe = document.createElement('iframe')
          const body = document.body
          iframe.style.cssText = 'display:none;width=0;height=0'
          body.appendChild(iframe)
          iframe.src = 'batchatnew://?crait'
          if (getBrowserInfo.isAndroid()) {
            if (getBrowserInfo.isWX()) {
              this.showWxMask = true
            } else {
              if (this.$i18n.locale === 'cn') {
                location.href = 'https://www.craitcorp.com/download/crait.apk'
              } else {
                location.href = 'https://play.google.com/store/apps/details?id=com.craitapp.crait'
              }
            }
          } else if (getBrowserInfo.isIOS()) {
            location.href = 'https://itunes.apple.com/app/id1227620003'
          }
        } else {
          window.location.href = `/login/index.html#/login/signup?account=${this.startInput}&source=website&v=${new Date().getTime()}`
        }
      }
      // window.location.href = `https://share.bat.chat/inv/1531291861KhBqlb?account=${this.startInput}&source=website&v=${new Date().getTime()}`
      // window.location.href = `https://bat.chat/login/index.html#/login/signup?account=${this.startInput}&source=website&v=${new Date().getTime()}`
      // window.location.href = `https://pre.bat.chat/inv/1532510125keboAM?account=${this.startInput}&source=website&v=${new Date().getTime()}`
      // window.location.href = `https://dl.craitapp.com/?v=${new Date().getTime()}`
      // window.location.href = `https://pre.bat.chat/website/option/share/index.html#/?token=15314629072pKLdA&type=invite&account=${this.startInput}&source=website&v=${new Date().getTime()}`
    },
    gotoWeb () {
      let a = document.createElement('a')
//      a.className = 'download-img'
      a.href = '/login/index.html#/'
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
//      window.location.href = 'https://www.craitapp.com/login/index.html#/'
    },
    gotoPC () {
      let a = document.createElement('a')
//      a.className = 'download-img'
      let href = getHost('fs')
      a.href = href + '/download/crait-setup.exe'
//      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
//      window.location.href = 'https://fs.craitapp.com/download/crait-setup.exe'
    },
    showQrCode (type) {
      const dlIphone = this.$refs.dlIphone
      const dlGphone = this.$refs.dlGphone
      const qrCodeBox = this.$refs.qrCodeBox
      this.qrCodeBox.show = 'visible'
      if (type === 'iphone') {
        this.qrCodeBox.top = dlIphone.offsetTop + 40 + 'px'
        this.qrCodeBox.left = dlIphone.offsetLeft - qrCodeBox.offsetWidth / 2 + dlIphone.offsetWidth / 2 + 'px'
      } else {
        this.qrCodeBox.top = dlGphone.offsetTop + 40 + 'px'
        this.qrCodeBox.left = dlGphone.offsetLeft - qrCodeBox.offsetWidth / 2 + dlGphone.offsetWidth / 2 + 'px'
      }
    },
    hideQrCode () {
      this.qrCodeBox.show = 'hidden'
    },
    checkInput (str) {
      let res
      const isNumReg = /^\d+$/
      const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      const phoneReg = /^\d{8,}$/
      if (isNumReg.test(str)) {
        if (phoneReg.test(str)) {
          res = 'success'
        } else {
          res = 'errPhone'
        }
      } else if (str.indexOf('@') > -1) {
        if (emailReg.test(str)) {
          res = 'success'
        } else {
          res = 'errEmail'
        }
      } else {
        res = 'success'
      }
      return res
    }
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
}
</script>

<style lang="scss">
.long-input {
  max-width: 565px;
}
.long-btn {
  width: 180px
}
.home {
  .cur {
    cursor: pointer;
  }
  .decoration {
    text-decoration: none
  }
  .title {
    color: #323232 !important;
    /*font-weight: 400 !important;*/
  }

  //背景图
  .bannerBackground {
    width: 100%;
    // height: 4rem;
    background-color: #fcfcfc;
    background: url('./imgs/main-banner.jpg') no-repeat center;
    background-size: cover;
    height: 6.5rem;
    .banner {
      width: 100%;
      /*max-width: 8.5rem;*/
      margin: 0 auto;
      text-align: center;
      color: #000;
      padding-top: 1.7rem;
      p:nth-of-type(1) {
        font-size:0.7rem;
        /*margin-bottom: 0.3rem;*/
        line-height: 0.8rem;
        font-weight: 400;
      }
      p:nth-of-type(2) {
        font-size:0.5rem;
        /*margin-bottom: 0.3rem;*/
        line-height: 0.7rem;
        /*font-weight: 600;*/
        color: #4287DB;
      }
      p:nth-of-type(3) {
        font-size:0.3rem;
        /*margin-bottom: 0.3rem;*/
        line-height: 0.7rem;
        /*font-weight: 600;*/
      }
      .input-info {
        width: 3.4rem;
        height: 0.6rem;
        vertical-align: middle;
        padding: 0 0.1rem;
        font-size: 0.24rem;
        color: #cacaca;
      }
      .input-info::-webkit-input-placeholder { /* WebKit browsers */
        color:    #cacaca;
      }
      .getStart {
        display: inline-block;
        width: 2.5rem;
        height: 0.6rem;
        color: #fff;
        vertical-align: middle;
        opacity: 0.8;
        line-height: 0.6rem;
        text-align: center;
        font-size: 0.24rem;
        background: #069734;
      }
      .getStart:hover {
        opacity: 1;
      }
    }
    .get-start {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      margin-top: 0.4rem;
      .el-input {
        max-width: 370px;
        width: 100%;
        input {
          border-right: none;
          border-radius: 4px 0 0 4px;
          height: 60px;
          line-height: 60px;
          padding-left: 20px;
          font-size: 20px;
        }
      }
      .el-button {
        border-left: none;
        border-radius: 0 4px 4px 0;
        width: 160px;
        // width: 300px;
        height: 60px;
        line-height: 36px;
        background: #5ea2ec;
        color: #fff;
        border: 0;
        font-size: 20px;
      }
    }
    /*@media screen and (max-width: 1024px) {*/
      /*height: 3rem;*/
      /*.banner {*/
        /*max-width: 6rem;*/
        /*height: 1.6rem;*/
        /*padding-top: 1.1rem;*/
        /*p {*/
          /*font-size: 0.25rem;*/
          /*margin-bottom: 0.1rem;*/
          /*line-height: 0.4rem;*/
        /*}*/
        /*.input-info {*/
          /*width: 2.5rem;*/
          /*height: 0.4rem;*/
          /*font-size: 0.18rem;*/
        /*}*/
        /*.getStart {*/
          /*width: 1.9rem;*/
          /*height: 0.4rem;*/
          /*line-height: 0.4rem;*/
          /*font-size: 0.18rem;*/
        /*}*/
      /*}*/
    /*}*/

    @media screen and (max-width: 760px) {
      height: 3.2rem;
      .banner {
        max-width: 4rem;
        // height: 100%;
        padding-top: .645rem;
        /*margin-left: 15%;*/
        p:nth-of-type(1) {
          font-size: 0.28rem!important;
          margin-bottom: 0.05rem;
          line-height: 0.3rem;
        }
        p:nth-of-type(2) {
          font-size: 0.2rem!important;
          margin-bottom: 0.1rem;
          line-height: 0.35rem;
          color: #4287DB;
        }
        p:nth-of-type(3) {
          font-size: 0.18rem!important;
          margin-bottom: 0.24rem;
          line-height: 0.22rem;
          color: #fff!important;
        }
        .input-info {
          width: 1.5rem;
          height: 0.3rem;
          font-size: 0.12rem;
        }
        .getStart {
          width: 1.3rem;
          height: 0.3rem;
          line-height: 0.3rem;
          font-size: 0.12rem;
        }
      }
      .get-start {
        margin-top: 0.24rem;
        .el-input {
          display: none;
          height: .3rem;
          line-height: .3rem;
          width: 1.8rem;
          input {
            border-right: none;
          }
        }
        .el-button {
          height: .44rem;
          line-height: .3rem;
          padding: 0 10px;
          width: 1.6rem;
          font-size: .2rem;
          border-radius: .04rem;
        }
      }
    }
  }
  //中部
  .mainContent{
    width: 100%;
    background: #fff;
    .crait-advantage {
      .home-intro {
        display: flex;
        -ms-box-orient: horizontal;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -moz-flex;
        display: -webkit-flex;
        align-items: center;
        .tool-pic {
          -webkit-box-flex: 1;      /* OLD - iOS 6-, Safari 3.1-6 */
          -moz-box-flex: 1;         /* OLD - Firefox 19- */
          /* width: 20%; */         /* For old syntax, otherwise collapses. */
          /* 见本文底部评论@Lawrence */
          -webkit-flex: 1;          /* Chrome */
          -ms-flex: 1;              /* IE 10 */
          flex: 1;                  /* NEW, Spec - Opera 12.1, Firefox 20+ */
          padding-top: 0.4rem;
        }
        .tool-pic img {
          width: 50vw;
        }
        .home-crait-advantage-intro{
          -webkit-box-flex: 1;      /* OLD - iOS 6-, Safari 3.1-6 */
          -moz-box-flex: 1;         /* OLD - Firefox 19- */
          /* width: 20%; */         /* For old syntax, otherwise collapses. */
          /* 见本文底部评论@Lawrence */
          -webkit-flex: 1;          /* Chrome */
          -ms-flex: 1;              /* IE 10 */
          flex: 1;                  /* NEW, Spec - Opera 12.1, Firefox 20+ */
          vertical-align: top;
          text-align: left;
          padding: 0.6rem 0 0.3rem;
          margin-left: 0.5rem;
        }
        .secureCommunication {
          margin-left: 3rem;
          .home-intro-title {
            width: 70%;
          }
          .home-intro-detail {
            width: 96%;
          }
        }
        .organization {
          .home-intro-title {
            width: 70%;
          }
        }
        @media screen and (max-width: 760px){
          .tool-pic img {
            width: 90vw;
          }
        }
      }
    }
    .key-features {
      .home-intro {
        .key-feature-lists {
          display: flex;
          -ms-box-orient: horizontal;
          display: -webkit-box;
          display: -moz-box;
          display: -ms-flexbox;
          display: -moz-flex;
          display: -webkit-flex;
          li {
            -webkit-box-flex: 1;      /* OLD - iOS 6-, Safari 3.1-6 */
            -moz-box-flex: 1;         /* OLD - Firefox 19- */
            /* width: 20%; */         /* For old syntax, otherwise collapses. */
            /* 见本文底部评论@Lawrence */
            -webkit-flex: 1;          /* Chrome */
            -ms-flex: 1;              /* IE 10 */
            flex: 1;                  /* NEW, Spec - Opera 12.1, Firefox 20+ */
            margin: 0.5rem 0;
            @media screen and (max-width: 760px){
              display: inline-block;
              width: 30%;
              vertical-align: top;
            }
            .feature-img {
              width: 1rem;
              height: 1rem;
              /*background: #E5F0FC;*/
              margin: 0 auto 0.1rem;
              img {
                width: 0.8rem;
                max-width: 100%;
                height: 0.8rem;
                max-height: 100%;
              }
            }
            .features-detail {
              font-size: 0.3rem;
              width: 3rem;
              margin: 0 auto;
              @media screen and (max-width: 760px){
                font-size: 0.2rem;
                width: 100%;
              }
            }
          }
        }
      }
      .key-feature-intro {
        margin: 0.5rem auto;
        padding: 0 1.9rem;
        @media screen and (max-width: 760px){
          padding: 0;
        }
        .learn-more {
          width: 3rem;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 0.2rem;
          background: #5CA4EC;
          border-radius: 3px;
          margin: 0 auto;
          font-weight: 400;
          a {
            text-decoration: none;
            color: #fff;
            width: 100%;
            display: inline-block;
          }
        }
      }
    }
    .download {
      padding: 0 !important;
      .small-screen {
        display: none;
        background-color: #fafafa;
        .bg-download{
          width: 100%;
          height: 2.8rem;
          background-image: url('../../assets/images/20181212/download_part_bg_m.jpg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .dl-title{
          font-weight: bold;
          font-size: 0.3rem;
          color: #fff;
          text-align: center;
          line-height: 0.3rem;
        }
        .dl-btn{
          margin-top: 0.26rem;
          width: 1.6rem;
          height: 0.44rem;
          background-color: #fff;
          border-radius: 0.04rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.2rem;
          color: #5ea2ec;
        }
        @media screen and (max-width: 760px){
          display: block;
        }
      }
      .large-screen {
        display: block;
        background-color: #fafafa;
        .bg-download{
          width: 100%;
          height: 600px;
          background-image: url('../../assets/images/20181212/download_part_bg.jpg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .get-start {
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 200px;
          .el-input {
            max-width: 560px;
            width: 100%;
            input {
              border-right: none;
              border-radius: 4px 0 0 4px;
              height: 80px;
              line-height: 80px;
              padding-left: 20px;
              font-size: 24px;
            }
          }
          .el-button {
            border-left: none;
            border-radius: 0 4px 4px 0;
            height: 80px;
            background: #5ea2ec;
            color: #fff;
            border: 0;
            font-size: 30px;
          }
        }
        .get-app{
          font-size: 30px;
          line-height: 30px;
          color: #666;
          margin-top: 40px;
          position: relative;
          u{
            cursor: pointer;
          }
          u:hover{
            color: #55a3e9;
          }
        }
        .qr-code-box{
          position: absolute;
          top: 0;
          left: 0;
          width: 166px;
          height: 214px;
          background-image: url('../../assets/images/20181212/qr_code_box.png');
          background-size: contain;
          background-repeat: no-repeat;
          padding-top: 30px;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          .qr-code{
            width: 130px;
            height: 130px;
            margin-bottom: 4px;
          }
          p{
            color: #999;
            font-size: 14px;
            line-height: 16px;
            padding: 0 4px;
          }
        }
        @media screen and (max-width: 760px){
          display: none;
        }
      }
    }
    .contact {
      .email-address {
        font-size: 0.3rem;
        color: #000;
        margin-bottom: 0.2rem;
        @media screen and (max-width: 760px){
          font-size: 0.2rem;
        }
        a {
          text-decoration: none;
          color: #000;
        }
      }
      .contact-us {
        width: 2rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.2rem;
        background: #5CA4EC;
        border-radius: 3px;
        margin: 0 auto;
        font-weight: 400;
        a {
          text-decoration: none;
          color: #fff;
          width: 100%;
          display: inline-block;
        }
      }
    }
    .home-praise {
      .home-title {
        margin: 0 0 1rem;
        @media screen and (max-width: 760px){
          font-size: 0.3rem !important;
          margin: 0 0 .5rem;
        }
      }
      .home-praise-img1, .home-praise-img2 {
        /*box-shadow: 0 2px 20px #888;*/
        width: 18.75vw;
        max-width: 100%;
        vertical-align: middle;
        @media screen and (max-width: 785px) {
          width: 75vw;
        }
      }
      .home-praise-part1, .home-praise-part2 {
        box-shadow: 0 2px 20px #888;
        display: inline-block;
        @media screen and (max-width: 785px) {
          box-shadow: 0 0 0;
        }
      }
      .home-praise-part2 {
        margin-top: 0.7rem;
        @media screen and (max-width: 785px) {
          margin-top: 25vw;
        }
        .evaluation {
          margin: 1vw 0 2.45vw;
        }
      }
      .home-praise-right {
        display: inline-block;
        height: 18.75vw;
        vertical-align: middle;
        padding: 2vw 3.6vw;
        /*box-shadow: 0 2px 20px #888;*/
        margin-left: -0.05rem;
        width: 49.5vw;
        text-align: left;
        font-size: 1.5vw;
        @media screen and (max-width: 785px) {
          width: 75vw;
          height: 55vw;
          font-size: 4.5vw;
        }
      }
      .quotes {
        width: 2.1vw;
      }
      .evaluation {
        margin: .75vw 0;
      }
      .home-praise-users-info {
        color: #323232;
        font-weight: bold;
      }
    }
    .home-part {
      padding: 1rem 0 0;
      text-align: center;
    }
    .home-info {
      width: 70%;
      margin: 0 auto;
    }
    .home-profile {
      font-size: 0.18rem;
      /*color: #888;*/
      margin: 0.25rem auto 0;
      width: 78%;
    }
    .home-title {
      font-size: 0.5rem;
      /*color: #303030;*/
      /*font-weight: 600;*/
    }
    .home-intro {
      i {
        display: inline-block;
      }
      .home-intro-title {
        font-size: 0.4rem;
        width: 57%;
        line-height: 0.45rem;
      }
      .home-intro-detail {
        width: 67%;
        font-size: 0.3rem;
        color: #888;
        margin: 0.25rem 0 0.2rem;
        line-height: 0.42rem;
      }
    }
    .home-contact-us {
      width: 3.4rem;
      height: 0.6rem;
      background: #00a3d8;
      color: #fff;
      position: absolute;
      left: 50%;
      margin-left: -1.7rem;
      font-size: 0.3rem;
      line-height: 0.6rem;
    }
    .home-sign-up {
      display: block;
      width: 3.4rem;
      height: 0.6rem;
      background: #069c34;
      color: #fff;
      font-size: 0.3rem;
      line-height: 0.6rem;
      margin: 0.3rem auto;
    }
    .home-part:nth-of-type(odd) {
      /*background: #fafafa;*/
    }
    @media screen and (max-width: 760px){
      .crait-advantage {
        padding: 0.5rem 0 0 !important;
      }
      .home-part {
        padding: 0.3rem 0;
        .home-info {
          width: 95%;
          margin-bottom: 0.5rem;
          .home-title {
            font-size: 0.3rem;
          }
        }
        .home-intro {
          /*display: block;*/
          flex-direction: column-reverse;
          margin-bottom: 0.5rem;
          .tool-pic {
            padding: 0;
          }
          .home-intro-title {
            font-size: 0.21rem;
            width: 100%;
            line-height: 0.3rem;
          }
          .home-intro-detail {
            font-size: 0.16rem;
            width: 92%;
            line-height: 0.24rem;
          }
          .home-crait-advantage-intro, .secureCommunication {
            margin-left: 0.2rem;
            padding: 0;
          }
          .organization .home-intro-title {
            width: 100%;
          }
          .key-feature-lists {
            display: block;
          }
        }
        .home-intro:nth-of-type(3) {
          flex-direction: column;
        }
      }
      .download {
        .home-info {
          margin-bottom: 0;
        }
      }
    }
      .home-contact-us {
        width: 2.5rem;
        height: 0.4rem;
        line-height: 0.4rem;
        margin-left: -1.25rem;
        font-size: 0.2rem;
      }
      .home-sign-up {
        width: 2.5rem;
        height: 0.4rem;
        line-height: 0.4rem;
        /*<!--margin-left: -1.25rem;-->*/
        font-size: 0.2rem;
      }
      /*.download .home-download {*/
        /*margin: 0.5rem 0;*/
      /*}*/
      /*.download .home-download .download-android {*/
        /*margin-bottom: 0.1rem;*/
        /*margin-right: 0;*/
      /*}*/
      /*.download .home-download i {*/
        /*width: 1.55rem;*/
        /*height: 0.4rem*/
      /*}*/
    }
    .get-start-inner{
      @media screen and (max-width: 760px){
        display: none;
      }
      position: relative;
      width: 100%;
      .input-err{
        input{
          border-color: #FA6362;
          background-color: #FEE5E5;
        }
      }
      .input-def{
        input{
          border-color: #dcdfe6;
          background-color: #fff;
        }
      }
      .err-tips{
        position: absolute;
        left: 0;
        font-size: 14px;
        line-height: 14px;
        color: #FA6362;
        margin-top: 10px;
        display: flex;
        align-items: center;
        .icon-prompt{
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?4de1e68b